// ------------------------------------
// HEADER
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header-variables';
    const ref2 = 'header';

    // Elementos
    const $header = $('.header');

    // Oculta/Exibe a seção
    function changeHeaderShow() {
      const value = confTheme[ref2]['header-show'];
      value == '1' ? $header.removeClass('d-none') : $header.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-header-show', changeHeaderShow);

    // Cor de fundo
    function changeHeaderBgColor() {
      const color = confTheme[ref]['header-bg-color'];
      //$header[0].style.setProperty('--header-bg-color', color);
      $header.each(function () {
        this.style.setProperty('--header-bg-color', color);
      });
    }
    $root.on(confEvtDefault + ' lp-evt-header-bg-color', changeHeaderBgColor);

    // Cor do texto
    function changeHeaderTxtColor() {
      const color = confTheme[ref]['header-txt-color'];
      //$header[0].style.setProperty('--header-txt-color', color);
      $header.each(function () {
        this.style.setProperty('--header-txt-color', color);
      });
    }
    $root.on(confEvtDefault + ' lp-evt-header-txt-color', changeHeaderTxtColor);
  }
})();

// ------------------------------------
// LOGOTIPO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header-variables';
    const ref2 = 'header';

    // Elementos
    const $logo = $('.header-logo');
    const $logoImg = $logo.find('img');

    // Altera a imagem
    function changeLogoImage() {
      const image = confTheme[ref2]['logo-src'];
      $logoImg.attr('src', image);
    }
    $root.on(confEvtDefault + ' lp-evt-header-logo-src', changeLogoImage);

    // Altera o texto alternativo da imagem
    function changeLogoAlt() {
      const value = confTheme[ref2]['logo-alt'];
      $logoImg.attr('alt', value);
    }
    $root.on(confEvtDefault + ' lp-evt-header-logo-alt', changeLogoAlt);

    // Altera o tamanho da imagem
    function changeLogoSize() {
      const value = confTheme[ref2]['logo-size'];
      $logo.removeClass('logo-sm logo-md logo-lg').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-header-logo-size', changeLogoSize);
  }
})();

// ------------------------------------
// BARRA SUPERIOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header-variables';
    const ref2 = 'header';

    // Elementos
    const $topBar = $('.top-bar');

    // Oculta/Exibe a barra superior
    function changeTopBarShow() {
      const value = confTheme[ref2]['top-bar-show'];
      value == '1' ? $topBar.removeClass('d-none') : $topBar.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-header-top-bar-show', changeTopBarShow);

    // Cor de fundo
    function changeTopBarBgColor() {
      const color = confTheme[ref]['top-bar-bg-color'];
      //$topBar[0].style.setProperty('--top-bar-bg-color', color);
      $topBar.each(function () {
        this.style.setProperty('--top-bar-bg-color', color);
      });
    }
    $root.on(confEvtDefault + ' lp-evt-header-top-bar-bg-color', changeTopBarBgColor);

    // Cor do texto
    function changeTopBarTxtColor() {
      const color = confTheme[ref]['top-bar-txt-color'];
      //$topBar[0].style.setProperty('--top-bar-txt-color', color);
      $topBar.each(function () {
        this.style.setProperty('--top-bar-txt-color', color);
      });
    }
    $root.on(confEvtDefault + ' lp-evt-header-top-bar-txt-color', changeTopBarTxtColor);

    // Texto da barra
    function changeTopBarText() {
      const value = confTheme[ref2]['top-bar-text'];
      $topBar.find('.top-bar-text').html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' lp-evt-header-top-bar-text', changeTopBarText);

    // Altera a cor de destaque do texto
    function changeTxtAltColor() {
      const color = confTheme[ref]['txt-alt-color'];
      //$topBar[0].style.setProperty('--txt-alt-color', color);
      $topBar.each(function () {
        this.style.setProperty('--txt-alt-color', color);
      });
    }
    $root.on(confEvtDefault + ' lp-evt-header-txt-alt-color', changeTxtAltColor);
  }
})();
